"use strict";

var _defineProperty = require("/builds/wildnow/athlete-dashboard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.params = void 0;

var _toParameterPattern = require("./_/to-parameter-pattern");

var params = function params(template, patterns) {
  var notFound = null;
  var pathPattern = toPathPattern(template);
  var parameterPattern = (0, _toParameterPattern.toParameterPattern)(template, patterns);
  return function (pathname) {
    var vs = matchPathPattern(pathname, pathPattern);
    if (vs === null) return notFound;
    var npvs = matchParameterPattern(vs, parameterPattern);
    if (npvs === null) return notFound;
    return toParameters(npvs);
  };
};

exports.params = params;

var toParameters = function toParameters(npvs) {
  return npvs.map(function (_ref) {
    var name = _ref.name,
        value = _ref.value;
    return _defineProperty({}, name, value);
  }).reduce(function (a, x) {
    return Object.assign(a, x);
  }, {});
};

var matchParameterPattern = function matchParameterPattern(parameterValues, parameterPattern) {
  var npvs = parameterValues.map(function (_ref3) {
    var value = _ref3.value;
    return decodeURIComponent(value);
  }).map(function (value, i) {
    var _parameterPattern$i = parameterPattern[i],
        name = _parameterPattern$i.name,
        pattern = _parameterPattern$i.pattern;
    return {
      name: name,
      pattern: pattern,
      value: value
    };
  });
  var hasUnmatchParameter = npvs.some(function (_ref4) {
    var pattern = _ref4.pattern,
        value = _ref4.value;
    return pattern !== null && value.match(pattern) === null;
  });
  if (hasUnmatchParameter) return null;
  var hasInvalidDuplicatedParameter = npvs.some(function (_ref5) {
    var name = _ref5.name,
        value = _ref5.value;
    return npvs.some(function (_ref6) {
      var n = _ref6.name,
          v = _ref6.value;
      return n === name && v !== value;
    });
  });
  if (hasInvalidDuplicatedParameter) return null;
  return npvs;
};

var matchPathPattern = function matchPathPattern(pathname, pathPattern) {
  var m = pathname.match(pathPattern);
  if (m === null) return null;
  var vs = m.slice(1).map(function (value) {
    return {
      value: value
    };
  });
  return vs;
};

var toPathPattern = function toPathPattern(template) {
  return new RegExp('^' + template.replace(/\{[A-Za-z0-9_-]+\}/g, '([^\\/]*)') + '$');
};